import React, { Component } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import "./Footer.scss";
const timestamp = new Date().getTime();
let path = "";
fetch("./newpath.json?v=" + timestamp)
  .then(function (res) {
    return res.json();
  })
  .then(function (data) {
    // store Data in State Data Variable
    path = data.prod;
  })
  .catch(function (err) {
    console.log(err, " error");
  });

class Footer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      privacypolicy: false,
      refundpolicy: false,
      tncpolicy: false,
      faq: false,

      //   isPrintOpen: false,
    };
  }
  closeModal = (name) => {
    this.setState({ [`${name}`]: false });
    // body.removeAttribute("data-lenis-prevent", true);
  };

  render() {
    return (
      <footer>
        <Container fluid="sm">
           <Row className="flex-row-reverse">
            <Col md={12} className="text-center">
              <Navbar.Brand href="#room"></Navbar.Brand>
            </Col>
            <Col xs={12} md={12}>
              <Row className="text-center">
                <Col xs={6} md={6} className="text-end pe-5">
                  <h2>Quick links</h2>
                  <Nav className="flex-column">
                    <Nav.Link href="#room">Rooms</Nav.Link>
                    <Nav.Link href="#profile">My Booking</Nav.Link>
                    <Nav.Link href="#about">About</Nav.Link>
                  </Nav>
                </Col>
                <Col xs={6} md={6} className="text-start ps-5">
                  <h2>Company</h2>
                  <Nav className="flex-column">
                    <Nav.Link
                      onClick={() => this.setState({ privacypolicy: true })}
                    >
                      Privacy policy
                    </Nav.Link>
                    <Nav.Link
                      onClick={() => this.setState({ refundpolicy: true })}
                    >
                      Refund policy
                    </Nav.Link>
                    <Nav.Link
                      onClick={() => this.setState({ tncpolicy: true })}
                    >
                      Terms & Conditions
                    </Nav.Link>
                    <Nav.Link onClick={() => this.setState({ faq: true })}>
                      F.A.Q
                    </Nav.Link>
                  </Nav>
                </Col>
              </Row>
              <br></br>
              <Row className="text-center">
                <h2>Legal entity - {localStorage.ml}</h2>
              </Row>
            </Col>
            
          </Row>
          {/* <Row className="flex-row-reverse">
            <Col xs={12} md={7}>
              <Row>
                <Col xs={6} md={5}>
                  <h2>Quick links</h2>
                  <Nav className="flex-column">
                    <Nav.Link href="#room">Rooms</Nav.Link>
                    <Nav.Link href="#profile">My Booking</Nav.Link>
                    <Nav.Link href="#about">About</Nav.Link>
                  </Nav>
                </Col>
                <Col xs={6} md={5}>
                  <h2>Company</h2>
                  <Nav className="flex-column">
                    <Nav.Link
                      onClick={() => this.setState({ privacypolicy: true })}
                    >
                      Privacy policy
                    </Nav.Link>
                    <Nav.Link
                      onClick={() => this.setState({ refundpolicy: true })}
                    >
                      Refund policy
                    </Nav.Link>
                    <Nav.Link
                      onClick={() => this.setState({ tncpolicy: true })}
                    >
                      Terms & Conditions
                    </Nav.Link>
                    <Nav.Link onClick={() => this.setState({ faq: true })}>
                      F.A.Q
                    </Nav.Link>
                  </Nav>
                </Col>
              </Row>
              <br></br>
              <Row className="text-center">
                <h2>Legal entity - FAYZ E TAHERI PRIVATE LTD</h2>
              </Row>
            </Col>
            <Col md={5}>
              <Navbar.Brand href="#home"></Navbar.Brand>
            </Col>
          </Row> */}
        </Container>
        <div className="footnote d-flex justify-content-center">
          <div className="text-center">
            Copyright @2025 Sigatul Mazaraat All Rights Reserved.
            <br></br>
            Version - {global.appVersion}
          </div>
          {/* <span>Version - {global.appVersion}</span> */}
        </div>

        <Modal
          show={this.state.privacypolicy}
          onHide={() => this.closeModal("privacypolicy")}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          // centered
          scrollable
          className="policymodal"
          data-lenis-prevent="true"
          // onShow={this.stopScroll}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Privacy Policy
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* <Form.Control as="textarea" value={this.state.testimony} /> */}
            <iframe
              style={{ width: "100%", height: "99%" }}
              src={`${path}/${"policy"}/${"privacypolicy.pdf"}?v=${timestamp}`}
            ></iframe>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => this.closeModal("privacypolicy")}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.refundpolicy}
          onHide={() => this.closeModal("refundpolicy")}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          // centered
          scrollable
          className="policymodal"
          data-lenis-prevent="true"
          // onShow={this.stopScroll}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Refund Policy
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* <Form.Control as="textarea" value={this.state.testimony} /> */}
            <iframe
              style={{ width: "100%", height: "99%" }}
              src={`${path}/${"policy"}/${"refundpolicy.pdf"}?v=${timestamp}`}
            ></iframe>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => this.closeModal("refundpolicy")}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.tncpolicy}
          onHide={() => this.closeModal("tncpolicy")}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          // centered
          scrollable
          className="policymodal"
          data-lenis-prevent="true"
          // onShow={this.stopScroll}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Terms & Conditions
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* <Form.Control as="textarea" value={this.state.testimony} /> */}
            <iframe
              style={{ width: "100%", height: "99%" }}
              src={`${path}/${"policy"}/${"tncpolicy.pdf"}?v=${timestamp}`}
            ></iframe>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => this.closeModal("tncpolicy")}>Close</Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.faq}
          onHide={() => this.closeModal("faq")}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          // centered
          scrollable
          className="policymodal"
          data-lenis-prevent="true"
          // onShow={this.stopScroll}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">F.A.Q</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* <Form.Control as="textarea" value={this.state.testimony} /> */}
            <iframe
              style={{ width: "100%", height: "99%" }}
              src={`${path}/${"policy"}/${"faq.pdf"}?v=${timestamp}`}
            ></iframe>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => this.closeModal("faq")}>Close</Button>
          </Modal.Footer>
        </Modal>
      </footer>
    );
  }
}

export default Footer;
